module.exports = __webpack_public_path__ + "img/sample-only.0799c989.svg";